/**
 * @generated SignedSource<<53ebe5e04900b2f04054ed42ed428a15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ShopAddressCheckerQuery$variables = {
  partialAddress: string;
};
export type ShopAddressCheckerQuery$data = {
  readonly location: {
    readonly address: {
      readonly suggestions: ReadonlyArray<{
        readonly value: string;
        readonly label: string;
      }>;
    };
  };
};
export type ShopAddressCheckerQuery = {
  variables: ShopAddressCheckerQuery$variables;
  response: ShopAddressCheckerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "partialAddress"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Location",
    "kind": "LinkedField",
    "name": "location",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AddressResponse",
        "kind": "LinkedField",
        "name": "address",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "partialAddress",
                "variableName": "partialAddress"
              }
            ],
            "concreteType": "AddressSuggestion",
            "kind": "LinkedField",
            "name": "suggestions",
            "plural": true,
            "selections": [
              {
                "alias": "value",
                "args": null,
                "kind": "ScalarField",
                "name": "elid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShopAddressCheckerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShopAddressCheckerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f517bcc795419eec7b3281b499a3fd4e",
    "id": null,
    "metadata": {},
    "name": "ShopAddressCheckerQuery",
    "operationKind": "query",
    "text": "query ShopAddressCheckerQuery(\n  $partialAddress: String!\n) {\n  location {\n    address {\n      suggestions(partialAddress: $partialAddress) {\n        value: elid\n        label\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c41282db1a0a146692975cd5a286fe20";

export default node;
